"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationLayer_1 = require("./AnimationLayer");
var VideoLayer = (function (_super) {
    tslib_1.__extends(VideoLayer, _super);
    function VideoLayer(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(VideoLayer.prototype, "videoId", {
        get: function () {
            return this._rawData.refId;
        },
        set: function (imageId) {
            this._rawData.refId = imageId;
        },
        enumerable: true,
        configurable: true
    });
    return VideoLayer;
}(AnimationLayer_1.AnimationLayer));
exports.VideoLayer = VideoLayer;
//# sourceMappingURL=VideoLayer.js.map